import React from 'react';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import AuthCheckManager from '../../Utils/AuthCheck/ManagerCheck.auth';
import { FormContainer } from '../../AdminRoutes/CreateRoutes/CreateForm.styles';
import CoursesDataProvider from '../../Utils/Courses/CoursesDataProvider';
import EmployeesDataProvider from '../../Utils/Companies/Managers-Employees/EmployeesDataProvider';
import ManagersDataProvider from '../../Utils/Companies/Managers-Employees/ManagersDataProvider';
import TrainingList from './TrainingListInner.component';
import { useParams } from 'react-router-dom';

const CompanyPurchasedCoursesList = () => {
  const { id } = useParams();
  return (
    <>
      <AuthCheckManager>
        <HelmetHelper
          title="Training List"
          description="Training list page for a company"
        />
        <FormContainer>
          <BreadCrumbs
            one="Company Dashboard"
            oneLink="/company"
            two="Training List"
          />
          <h2>Training List</h2>
          <CoursesDataProvider>
            {(courses) => (
              <EmployeesDataProvider companyId={id}>
                {(employees) => (
                  <ManagersDataProvider companyId={id}>
                    {(managers) => (
                      <TrainingList
                        courses={courses}
                        employees={employees}
                        managers={managers}
                      />
                    )}
                  </ManagersDataProvider>
                )}
              </EmployeesDataProvider>
            )}
          </CoursesDataProvider>
        </FormContainer>
      </AuthCheckManager>
    </>
  );
};

export default CompanyPurchasedCoursesList;
